import { render, staticRenderFns } from "./AccountReview.vue?vue&type=template&id=15f5b90c"
import script from "./AccountReview.vue?vue&type=script&lang=js"
export * from "./AccountReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports